export default __webpack_public_path__ + "static/media/perp-placeholder.3c11b9f5.png";